import { Box, Button, Container, Grid, Stack, TextareaAutosize, TextField, Typography } from '@mui/material';
import { useWeb3React } from '@web3-react/core';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { Label } from 'semantic-ui-react';
import Preview from "../../images/Profile.png";
import swal from "sweetalert";
import { API_URL, APP_URL } from "../../Config/index";
import axios from 'axios';
import Loading from '../../Components/loader/loader';

const Editprofile = () => {
  const { account, active, library } = useWeb3React();
  const [profileimage, setImg] = useState("");
  const [previewprofile, setprofilepreview] = useState(Preview);
  const [coverimg, Setcoverimg] = useState("");
  const [previewcover, setcoverpreview] = useState("");
  const [isloading, setisloading] = useState(false);
  const [userdata, setuserdata] = useState("");

  // setuserinfo 
  const [username, setusername] = useState("");
  const [bio, setbio] = useState("");
  const [email, setemail] = useState("");
  const [twitter, settwitter] = useState("");
  const [insta, setinstaname] = useState("");
  const [facebook, setfacebook] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (library) {

      const username = e.target.username.value;
      const Bio = e.target.Bio.value;
      const email = e.target.email.value;
      const twitteraccount = e.target.twitteraccount.value;
      const Instagram = e.target.instagramaccount.value;
      const facebookurl = e.target.facebookaccount.value;

      if (username != "") {
        setisloading(true);
        var data = new FormData();
        data.append("address", account);
        data.append("Username", username);
        data.append("Email", email);
        data.append("Bio", Bio);
        data.append("avatar", profileimage);
        data.append("cover", coverimg);
        data.append("facebookurl", facebookurl);
        data.append("Instagram", Instagram);
        data.append("Twitter", twitteraccount);
        await axios.post(`${API_URL}/edit_profile.php`, data, {
          headers: {
            'Content-Type': "multipart/form-data",
          }
        })
          .then(res => {
            setisloading(false);
            console.log(res.data);
            if(res.data.code ==200){

              swal({ 
                icon: "success", 
                text: `${res.data.message}`,
                title: "success" 
              })
              .then(re => {
                window.location.reload();
              });

            }else{
                swal({ 
                  icon: "error", 
                  text: `${res.data.message}`,
                  title: "error" 
                })
            }
          

          })
          .catch(err => {
            setisloading(false);
            swal("error", "Something went wrong", "error");
          })

      } else {
        swal("warning", "Please fill a required fields", "warning");
      }
    } else {
      swal("warning", "Please connect your wallet first", "warning")
    }
  }

  const getimage = (e) => {
    if (e.target.files && e.target.files.length > 0) setImg(e.target.files[0]);
  };

  const getcoverimg = (e) => {
    if (e.target.files && e.target.files.length > 0) Setcoverimg(e.target.files[0]);
  }

  const getuserDetails = async () => {

    await axios
      .post(`${API_URL}/my-items.php?type=users&address=${account}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {

        setuserdata(res.data[0]);
        setusername(res.data[0].Username)
        setbio(res.data[0].Userbio)
        setemail(res.data[0].Useremail)
        settwitter(res.data[0].Usertwitname)
        setinstaname(res.data[0].Userinstaname)
        setfacebook(res.data[0].Userfacebookname)
        // Setcoverimg(res.data[0].coverphoto);
        // setImg(res.data[0].Userimage);
        setprofilepreview(`${APP_URL}${res.data[0].Userimage}`)
        setcoverpreview(`${APP_URL}${res.data[0].coverphoto}`)
      })
      .catch(console.log);
  };


  useEffect(() => {
    if (active) {
      getuserDetails();
    }
  }, [active, account]);

  useEffect(() => {
    if (profileimage?.length < 1) return;
    const newImages = URL.createObjectURL(profileimage);
    setprofilepreview([newImages]);

  }, [profileimage]);

  useEffect(() => {
    if (coverimg?.length < 1) return;
    const newImages = URL.createObjectURL(coverimg);
    setcoverpreview([newImages]);

  }, [coverimg]);
  return (
    <>
      <Box className='createcollection_bg'>
        <Typography variant='h2' fontWeight='600' fontSize='45px'>
          Edit Profile
        </Typography>
      </Box>
      <Box className=''>
        <Container maxWidth='xl' component='form' method="post" onSubmit={handleSubmit} >
          <Grid container spacing={2}>
            <Grid item lg={8} sm={12} md={12} xs={12}>
              <Box className='create_items'>
                <Typography variant='h4' fontSize='22px' fontWeight='500' paddingBottom='10px'>Edit Profile</Typography>
                <hr style={{ border: '1px solid #e9e9e9' }}></hr>

                <Container maxWidth='xl' className='imaginations'>
                  <Grid container spacing={2} padding='0px !important'>
                    <Grid item lg={6} sm={12} md={12} xs={12}>
                      <Typography variant='h5' fontWeight='500' fontSize='17px' paddingBottom='5px' paddingTop='10px'>Upload Profile Image</Typography>
                      <Box className='recognize'>
                        <Typography variant='h6' fontWeight='400' fontSize='16px' paddingBottom='20px'>JPG, PNG, GIF, WEBP, Max 100mb.</Typography>
                        <Stack direction="row" spacing={2}>
                          <Button variant="contained" component="label">
                            Upload image
                            <input hidden accept="image/*" multiple type="file" onChange={getimage} />
                          </Button>
                        </Stack>
                      </Box>
                    </Grid>
                    <Grid item lg={6} sm={12} md={12} xs={12}>
                      <Typography variant='h5' fontWeight='500' fontSize='17px' paddingBottom='5px' paddingTop='10px'>Upload Cover Image</Typography>
                      <Box className='recognize'>
                        <Typography variant='h6' fontWeight='400' fontSize='16px' paddingBottom='20px'>JPG, PNG, GIF, WEBP, Max 100mb.</Typography>
                        <Stack direction="row" spacing={2}>
                          <Button variant="contained" component="label">
                            Upload image
                            <input hidden accept="image/*" multiple type="file" onChange={getcoverimg} />
                          </Button>
                        </Stack>
                      </Box>
                    </Grid>
                  </Grid>
                </Container>

                <Box>
                  <Container maxWidth='xl' className='coll_det'>
                    <Grid container spacing={2}>
                      <Grid item lg={6} sm={12} md={12} xs={12}>
                        <Label> Name *required</Label>
                        <TextField id="outlined-basic" type='text' fullWidth variant="outlined" name="username" value={username} onChange={(e) => setusername(e.target.value)} />

                      </Grid>

                      <Grid item lg={6} sm={12} md={12} xs={12}>
                        <Label>Bio</Label>
                        <TextField id="outlined-basic" fullWidth variant="outlined" value={bio} name="Bio" onChange={(e) => setbio(e.target.value)} />
                      </Grid>

                      <Grid item lg={6} sm={12} md={12} xs={12}>
                        <Label>Email</Label>
                        <TextField id="outlined-basic" fullWidth variant="outlined" value={email} name="email" onChange={(e) => setemail(e.target.value)} />
                      </Grid>

                      <Grid item lg={6} sm={12} md={12} xs={12}>
                        <Label>Twitter Account</Label>
                        <TextField id="outlined-basic" fullWidth variant="outlined" value={twitter} name="twitteraccount" onChange={(e) => settwitter(e.target.value)} />
                      </Grid>

                      <Grid item lg={6} sm={12} md={12} xs={12}>
                        <Label>Instagram Account</Label>
                        <TextField id="outlined-basic" fullWidth variant="outlined" value={insta} name="instagramaccount" onChange={(e) => setinstaname(e.target.value)} />
                      </Grid>

                      <Grid item lg={6} sm={12} md={12} xs={12}>
                        <Label>Facebook Account</Label>
                        <TextField id="outlined-basic" fullWidth variant="outlined" value={facebook} name="facebookaccount" onChange={(e) => setfacebook(e.target.value)} />
                      </Grid>
                      <Grid item lg={12} sm={12} md={12} xs={12}>
                        <Label>Address </Label>
                        <TextField id="outlined-basic" fullWidth value={account} variant="outlined" name="Address" />
                        <Button marginY='20px' type="submit" variant="contained"> Submit</Button>
                      </Grid>
                    </Grid>
                  </Container>
                </Box>
              </Box>
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <Box className='create_items'>
                <Typography variant='h4' fontSize='22px' fontWeight='500' paddingBottom='10px'>Profile Image</Typography>
                <hr style={{ border: '1px solid #e9e9e9' }}></hr>
                <Box className='preview_box' marginY='30px' style={{ border: '1px solid #e9e9e9', borderRadius: '15px' }} padding='10px'>
                  <img src={previewprofile ? previewprofile : Preview} width='100%' style={{ borderRadius: '15px' }} />
                </Box>
              </Box>

              <Box className='create_items'>
                <Typography variant='h4' fontSize='22px' fontWeight='500' paddingBottom='10px'>Cover Image</Typography>
                <hr style={{ border: '1px solid #e9e9e9' }}></hr>
                <Box className='preview_box' marginY='30px' style={{ border: '1px solid #e9e9e9', borderRadius: '15px' }} padding='10px'>
                  <img src={previewcover ? previewcover : Preview} width='100%' style={{ borderRadius: '15px' }} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {isloading && <Loading props={'Profile is updating'} />}
    </>
  )
}

export default Editprofile;